import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { getOrder, updateOrder } from '../../../order'
import * as locations from '../../../../addressbook/locations'
import Alert from '../../../../../ui/Alert'
import Bar from '../../../../../ui/Bar'
import Button from '../../../../../ui/Button'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Immutable from 'immutable'
import Page from '../../../../app/components/Page'
import styles from '../css/Shipping.scss'
import ListItem from './ListItem'
import LocationSearch from './LocationSearch'

export class LazyLoadingLocations extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        onSelect: PropTypes.func.isRequired,
        recentLocations: ImmutablePropTypes.list.isRequired,
        recentPagination: PropTypes.object,
        loadingRecent: PropTypes.bool.isRequired,
        searchResults: ImmutablePropTypes.list.isRequired,
        searchTerm: PropTypes.string.isRequired,
    }

    constructor (props) {
        super(props)
        this.state = {
            loadingMore: false,
        }
    }

    componentDidMount() {
        const { recentLocations } = this.props
        // Only load if we don't already have recent locations
        if (recentLocations.size === 0) {
            this.loadRecentLocations()
        }
    }

    componentDidUpdate(prevProps) {
        // Reset loadingMore state when loading is done
        if (prevProps.loadingRecent && !this.props.loadingRecent && this.state.loadingMore) {
            this.setState({ loadingMore: false })
        }
    }

    componentWillUnmount() {
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout)
        }
    }

    handleNewAddress () {
        const { order, dispatch } = this.props
        const newOrder = order.set('shipToNewAddress', true)
        dispatch(updateOrder(newOrder))
    }


    loadRecentLocations = (page = 1, append = false) => {
        const { dispatch } = this.props
        this.setState({ loadingMore: append })
        dispatch(locations.getRecentLocations({ page }, { append }))
    }

    handleLoadMore = () => {
        const { recentPagination } = this.props
        if (recentPagination && recentPagination.has_more) {
            this.loadRecentLocations(recentPagination.current_page + 1, true)
        }
    }

    render () {
        const { loadingMore } = this.state
        const { order, onSelect, recentLocations, recentPagination, loadingRecent, searchResults, searchTerm } = this.props

        // Filter locations by region and visibility
        const filteredRecentLocations = recentLocations.filter(location => {
            return location.get('address') &&
                   location.getIn(['address', 'regionId']) === order.get('region') &&
                   !location.get('hidden')
        }).toJS()

        // Filter search results by region and visibility
        const filteredSearchResults = searchResults.filter(location => {
            return location.get('address') &&
                   location.getIn(['address', 'regionId']) === order.get('region') &&
                   !location.get('hidden')
        }).toJS()

        const displayedLocations = searchTerm.trim() ? filteredSearchResults : filteredRecentLocations
        const hasSearchTerm = searchTerm.trim().length > 0
        const noSearchResults = hasSearchTerm && filteredSearchResults.length === 0

        return (
            <Page.Content>
                <div className={styles.filter}>
                    <Bar.Section
                        float="left"
                        className={styles.actions}
                    >
                        <LocationSearch onClearSearch={this.handleClearSearch} />
                        <Button
                            block
                            emphasis="secondary"
                            className={styles.createNewAddress}
                            onClick={this.handleNewAddress.bind(this)}
                        >
                            <FormattedMessage id="frontend.form_selector_shipping.button.new_address"/>
                        </Button>
                    </Bar.Section>
                </div>


                {/* Locations List */}
                <div>
                    <h3 style={{ marginBottom: '15px' }}>
                        {hasSearchTerm ?
                            <FormattedMessage id="frontend.form_selector_shipping.headline.search_results" /> :
                            <FormattedMessage id="frontend.form_selector_shipping.headline.recent_locations" />
                        }
                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#666' }}>
                            {hasSearchTerm ?
                                ` (${filteredSearchResults.length} ` :
                                ` (${filteredRecentLocations.length} `
                            }
                            {hasSearchTerm ?
                                <FormattedMessage id="frontend.form_selector_shipping.text.found" /> :
                                <FormattedMessage id="frontend.form_selector_shipping.text.loaded" />
                            })
                        </span>
                    </h3>

                    {loadingRecent && (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <FormattedMessage id="frontend.form_selector_shipping.text.loading_recent_locations" />
                        </div>
                    )}

                    {!loadingRecent && filteredRecentLocations.length === 0 && !hasSearchTerm && (
                        <Alert type="info">
                            <FormattedMessage id="frontend.form_selector_shipping.text.no_recent_locations" />
                        </Alert>
                    )}

                    {noSearchResults && (
                        <Alert type="warning">
                            <FormattedMessage
                                id="frontend.form_selector_shipping.text.no_search_results"
                                values={{ searchTerm }}
                            />
                        </Alert>
                    )}

                    {displayedLocations.length > 0 && (
                        <div>
                            {/* Locations without container restrictions */}
                            <div style={{ paddingBottom: '20px' }}>
                                {displayedLocations.map((location) => (
                                    <ListItem
                                        key={location.id}
                                        location={Immutable.fromJS(location)}
                                        onSelect={onSelect}
                                    />
                                ))}
                            </div>

                            {/* Load More Button - for pagination (only show when not searching) */}
                            {!hasSearchTerm && recentPagination && recentPagination.has_more && (
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <Button
                                        emphasis="primary"
                                        onClick={this.handleLoadMore}
                                        disabled={loadingMore}
                                        style={{ minWidth: '200px' }}
                                    >
                                        {loadingMore ?
                                            <FormattedMessage id="frontend.form_selector_shipping.button.loading" /> :
                                            <FormattedMessage
                                                id="frontend.form_selector_shipping.button.load_more"
                                                values={{ remaining: recentPagination.total - filteredRecentLocations.length }}
                                            />
                                        }
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </Page.Content>
        )
    }
}

export default connect(state => ({
    order: getOrder(state),
    recentLocations: locations.selectRecentLocations(state),
    recentPagination: locations.selectRecentPagination(state),
    loadingRecent: locations.selectLoadingRecent(state),
    searchResults: locations.selectSearchResults(state),
    searchTerm: locations.selectSearchTerm(state),
}))(LazyLoadingLocations)
